var $4d8ca888adc67de0$exports = {};
$4d8ca888adc67de0$exports = {
  "pending": "laukiama"
};
export { $4d8ca888adc67de0$exports as default };